module.exports = __webpack_public_path__ + "static/media/care_hawaii1.6d92f8db.jpg";